import { getSharedRootStore } from '@bringg-frontend/global-stores';

export async function fetchUser(userId: number) {
	if (!userId) {
		return null;
	}
	try {
		const { driversStore } = getSharedRootStore().data;
		return await driversStore.load(userId);
	} catch (err) {
		console.error(`Failed to fetch user ${userId}`, err);
	}

	return null;
}
